import { RequestType, requestTypeNavigateParser } from "../interfaces";

export function redirectToPinScreenResolver(
  requestId: string | null,
  requestType?: RequestType | null
) {
  if (!requestId || !requestType) return "/app/solicitudes";
  return `/app/solicitudes/${requestId}/${requestTypeNavigateParser[requestType]}/firma`;
}
